import { useMemo } from 'react';
import { registerFieldComponent, StepFormApp, type AppSettings } from '@stepform';
import { RadioDependantField } from '../extractives/components/DependantFields';
import { buildSchema } from './schema';
import { MentalHealthDisplayService } from './displayService';
import { MentalHealthValidationService } from './validationService';
import { MentalHealthStateService } from './stateService';
import { MentalHealthReviewStep } from './components/MentalHealthReviewStep';

registerFieldComponent('RadioDependant', RadioDependantField);

const customStepComponents = {
  MentalHealthReview: MentalHealthReviewStep,
};

export function MentalHealthApp({ settings }: { settings: AppSettings }) {
  const schema = useMemo(
    () =>
      buildSchema(
        settings.fieldOptions,
        settings.concernDetailsThingsToInclude
      ),
    [settings.fieldOptions, settings.concernDetailsThingsToInclude]
  );

  return (
    <StepFormApp
      settings={{
        submitButtonLabel: 'Submit',
        continueAlwaysEnabled: true,
        stepIndicatorStyle: 'enhanced',
        hideStepTitlesWithQuestions: false,
        ...settings,
      }}
      schema={schema}
      ValidationServiceClass={MentalHealthValidationService}
      DisplayServiceClass={MentalHealthDisplayService}
      StateServiceClass={MentalHealthStateService}
      customStepComponents={customStepComponents}
    />
  );
}
